// export const BASEURL = `https://brij-api-v1.empirecinemas.com/`;

export const BASEURL = `https://api.cinemacitybeirut.com`;

// export const ImageS3URL = `https://images.brijimages.com/`;
export const IMGBASEURL = `https://api.cinemacitybeirut.com`;

export const fallbackImgSrc = `${BASEURL}assets/fallback-image.png`;
export const fallbackImgBannerSrc = `${BASEURL}assets/fallback-image-banner.png`;
export const SALES_APP = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6ImVlZjc3YjI0LTA2M2MtNDAyMC1hNmZlLTJjNGY2MmYwYTEzZiIsImlhdCI6MTc5MDkyNDk5MH0.ArMQFF-VzKE0ol-97fc_ndCIN6W97uhu6wTkmjNGWKI`
export const TOKEN = SALES_APP



// WEBPACK FOOTER //
// ./src/config/index.js